import { render, staticRenderFns } from "./RabbeyTable2.vue?vue&type=template&id=6e3c0c50&"
import script from "./RabbeyTable2.vue?vue&type=script&lang=js&"
export * from "./RabbeyTable2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports